module.exports = __webpack_public_path__ + "static/img/landmark.5d05b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landmark.png
// module id = ao++
// module chunks = 1